import {
  FaFacebookF,
  FaGithub,
  FaInstagram,
  FaLinkedinIn,
  FaPhone,
  FaWhatsapp,
} from "react-icons/fa";

const Footer = () => {
  return (
    <div id="footer" className="text-center">
      <hr />
      <div className="my-4" data-aos="fade-down">
        <img
          width={50}
          src="/images/logos-removebg-preview.2878fb6bf5cfd441c9bf (1).png"
          alt=""
        />
      </div>
      <small data-aos="fade-right">© Copyright 2021. All right reserved</small>
      <div className="d-flex gap-md-5 gap-4 mx-auto text-center justify-content-center mt-3 mb-5">
        <a
          href="https://www.linkedin.com/in/md-shoyeb-49645020a/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green"
        >
          <FaLinkedinIn size={30} />
        </a>
        <a
          href="http://wa.me/919871904481"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green"
        >
          <FaWhatsapp size={30} />
        </a>

        <a
          href="http://github.com/shoyebmd424"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green"
        >
          <FaGithub size={30} />
        </a>
        <a
          href="http://facebook.com/shoyeb"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green"
        >
          <FaFacebookF size={30} />
        </a>
        <a
          href="http://instagram.com/shoyebmd424"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green"
        >
          <FaInstagram size={30} />
        </a>
        <a
          href="tel:+919871904481"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green"
        >
          <FaPhone size={30} />
        </a>
      </div>
    </div>
  );
};

export default Footer;
